import { svg } from "lit";
const icon = svg `<path d="M23.3503 29.4232L13.9102 19.9831L23.3503 10.5322L24.8417 12.0236L16.893 19.9831L24.8417 27.9318L23.3503 29.4232Z" fill="currentColor"/>`;
export default icon;
